module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#close",
      toString: function () {
        return this.url;
      }
    }